import React, { useState, useEffect } from 'react';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, TextField, Button, Paper } from '@mui/material';
import axios from 'axios';

const Timesheet = () => {
  const [entries, setEntries] = useState([]);
  const [newEntry, setNewEntry] = useState({ project: '', task: '', hours: '' });

  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    try {
      const res = await axios.get('/api/timesheet');
      setEntries(res.data);
    } catch {
      setEntries([]);
    }
  };

  const handleChange = (e) => setNewEntry({ ...newEntry, [e.target.name]: e.target.value });
  const handleAdd = async () => {
    if (!newEntry.project || !newEntry.task || !newEntry.hours) return;
    try {
      await axios.post('/api/timesheet', { ...newEntry, hours: Number(newEntry.hours) });
      fetchEntries();
      setNewEntry({ project: '', task: '', hours: '' });
    } catch {}
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Zaman Çizelgesi</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">Yeni Kayıt</Typography>
        <TextField label="Proje" name="project" value={newEntry.project} onChange={handleChange} sx={{ mr: 1 }} />
        <TextField label="Görev" name="task" value={newEntry.task} onChange={handleChange} sx={{ mr: 1 }} />
        <TextField label="Saat" name="hours" type="number" value={newEntry.hours} onChange={handleChange} sx={{ mr: 1, width: 80 }} />
        <Button variant="contained" onClick={handleAdd}>Ekle</Button>
      </Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Proje</TableCell>
            <TableCell>Görev</TableCell>
            <TableCell>Saat</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.map((e) => (
            <TableRow key={e.id}>
              <TableCell>{e.project}</TableCell>
              <TableCell>{e.task}</TableCell>
              <TableCell>{e.hours}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default Timesheet;
